import React from 'react';

import Box from '@mui/material/Box';

import {
  StandardMenuHeroRestaurantName,
  StandardMenuHeroAddress,
  StandardMenuHeroPhoneNumber,
  ownTextState,
  ownIconState,
  detailsSx
} from 'bento-ordering/menus/components/StandardMenuHeroLocationInformationBlocks';
import { StandardMobileMenuHeroLocationInformation } from 'bento-ordering/menus/components/StandardMenuHeroLocationInformation';
import GridContainer from 'bento-ordering/base/ui_components/GridContainer';
import useOnlineOrderingLocationInformation from 'hooks/useOnlineOrderingLocationInformation';
import { useOnlineOrderingDisplayLocationInformationOnLayout } from 'hooks/useDisplayLocationInformationOnLayout';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { DEFAULT_LAYOUT_PADDING } from 'styles/constants/layoutPadding';
import { getSectionNavMediumColor } from 'styles/helpers/getThemeStyles';

function StandardMenuHeroLocationInformationWithoutImage() {
  const isMobile = useIsMobile();
  const locationInformation = useOnlineOrderingLocationInformation();
  const shouldDisplayLocationInformationOnLayout = useOnlineOrderingDisplayLocationInformationOnLayout();

  if (!locationInformation || !shouldDisplayLocationInformationOnLayout) {
    return null;
  }
  const {
    locationName,
    street,
    city,
    state,
    postalCode,
    phoneNumber
  } = locationInformation;

  const padding = isMobile ? { pt: 2.5 } : DEFAULT_LAYOUT_PADDING;

  if (isMobile) {
    return (
      <GridContainer>
        <StandardMobileMenuHeroLocationInformation {...locationInformation} />
      </GridContainer>
    );
  }

  return (
    <GridContainer {...padding}>
      <StandardMenuHeroRestaurantName
        locationName={locationName}
        ownState={ownTextState(() => ({
          fontSize: '28px',
          marginBottom: '10px',
          marginTop: '30px'
        }))}
      />
      <Box
        sx={{
          display: 'flex',
          marginBottom: '10px',
          flexFlow: 'row wrap'
        }}
      >
        <StandardMenuHeroAddress
          street={street}
          city={city}
          state={state}
          postalCode={postalCode}
          IconProps={{
            ownState: ownIconState()
          }}
          DetailProps={{
            ownState: ownTextState(theme => ({
              fontSize: '14px',
              color: getSectionNavMediumColor(theme)
            }))
          }}
        />
        <StandardMenuHeroPhoneNumber
          phoneNumber={phoneNumber}
          IconProps={{
            ownState: ownIconState()
          }}
          LabelProps={{
            variant: ITEM_DESCRIPTION_AND_PRICES,
            ownState: ownTextState(theme => ({
              ...detailsSx,
              fontSize: '14px',
              color: getSectionNavMediumColor(theme),
              '&:hover': {
                color:
                  theme.palette.sectionNav.link.hover ?? theme.palette.mediumSoy
              }
            }))
          }}
        />
      </Box>
    </GridContainer>
  );
}

export default StandardMenuHeroLocationInformationWithoutImage;
